<template>
	<div class="card mt-4">
        <div class="card-header">
	    	<div class="d-flex justify-content-between container-fluid">
	            <div class="text-muted fs-19">
	            	<strong>Registros</strong>
	            </div>
		    </div>
	    </div>
	    <div class="card-body">
	    	<div class="row">
				<div class="col-md-12">
		            <despesa-table 
		            	:date="date"
		            	:key="despesaTableKey"
		            	@show="show">
		            </despesa-table>
		        </div>
		    </div>
	    </div>
	</div>
</template>

<script>
	export default {
		props: ['date', 'despesaTableKey'],
		methods: {
			show(id){
            	this.$emit('show', id);
	        }
		},
	}
</script>